import { Component, inject } from '@angular/core';
import { ErrorBarService } from "../../services/error-bar.service";
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-error-bar',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './error-bar.component.html'
})
export class ErrorBarComponent {
  public errorBarService: ErrorBarService = inject(ErrorBarService);
}
